// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DuplicateModal_modalOverlay__NIZ69 {
  position: fixed;
  top: 0;
  left: 15%;
  width: 85%;
  height: 100%;
  background-color: #000000d6;
  z-index: 100;
}
.DuplicateModal_modalOverlay__NIZ69 {
  display: flex;
  align-items: center;
  justify-content: center;
}
.DuplicateModal_infoModal__lDHh7 {
  flex-direction: column;
  width: 70%;
  padding: 24px 0px 24px 0px;
  justify-content: center;
  gap: 24px;
}
.DuplicateModal_exitBtn__3yNGh {
  position: absolute;
  top: 5%;
  right: 3%;
  cursor: pointer;
}
.DuplicateModal_title__TLD4D {
  font-family: Inter;
  font-size: 28px;
  font-weight: 600;
  line-height: 34px;
  letter-spacing: -0.001em;
  text-align: left;
  color: #4d4d4d;
}

.DuplicateModal_infoModal__lDHh7,
.DuplicateModal_btnRow__P4\\+BN,
.DuplicateModal_modalWrapper__56czI {
  display: flex;
  align-items: center;
}
.DuplicateModal_modalWrapper__56czI {
  justify-content: flex-start;
  flex-direction: column;
  width: 60%;
  border-radius: 16px;
  border: 1px solid #d1d9e2;
  box-shadow: 0px 1px 2px 0px #1018280d;
  background-color: #ffffff;
}
.DuplicateModal_inputWrapper__aJIe7 {
  width: 100%;
  gap: 16px;
  margin-top: 24px;
}
.DuplicateModal_inputWrapper__aJIe7,
.DuplicateModal_inputColumn__8wuks {
  display: flex;
  flex-direction: column;
  align-items: baseline;
  justify-content: center;
}
.DuplicateModal_inputColumn__8wuks {
  width: 98%;
}
.DuplicateModal_label__oD8Is {
  text-align: left;
  color: #5f6d7e;
}
.DuplicateModal_modalInput__AsV9w {
  width: 100%;
}
.DuplicateModal_btnRow__P4\\+BN {
  justify-content: flex-end;
  gap: 24px;
  width: 100%;
  margin-top: 48px;
  margin-bottom: 32px;
}
.DuplicateModal_modalInput__AsV9w {
  padding: 8px;
  height: 42px;
  border: 1px solid #d8dbdf;
  border-radius: 8px;
  text-align: left;
  color: #5f6d7e;
  box-shadow: 4px 4px 64px 0px #5f6d7e1a;
  font-family: Inter;
  font-size: 16px;
  font-weight: 500;
  letter-spacing: -0.001em;
}
.DuplicateModal_cancelBtn__aThte,
.DuplicateModal_successBtn__Gi7uF {
  width: 30%;
  border: none;
  padding: 8px 16px;
  border-radius: 4px;

  cursor: pointer;
  height: 52px;
}
.DuplicateModal_cancelBtn__aThte,
.DuplicateModal_successBtn__Gi7uF,
.DuplicateModal_label__oD8Is {
  font-family: Inter;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 22px;
  letter-spacing: -0.016px;
}

.DuplicateModal_successBtn__Gi7uF {
  background: #cb9c2d;
  color: #fff;
}
.DuplicateModal_successBtn__Gi7uF:hover {
  background-color: #9b7725;
}
.DuplicateModal_cancelBtn__aThte {
  background-color: #ebebeb;
  color: #808080;
}
.DuplicateModal_cancelBtn__aThte:hover {
  background-color: #a09f9f;
  color: #fff;
}

@media screen and (max-width: 1300px) {
  .DuplicateModal_modalOverlay__NIZ69 {
    width: 100%;
    left: 0%;
  }
  .DuplicateModal_successBtn__Gi7uF,
  .DuplicateModal_cancelBtn__aThte {
    width: 35%;
  }
  .DuplicateModal_btnRow__P4\\+BN {
    margin-bottom: 0px;
  }
}

@media screen and (max-width: 1050px) {
  .DuplicateModal_successBtn__Gi7uF,
  .DuplicateModal_cancelBtn__aThte {
    width: 40%;
  }
}

@media screen and (max-width: 920px) {
  .DuplicateModal_successBtn__Gi7uF,
  .DuplicateModal_cancelBtn__aThte {
    width: 40%;
  }
  .DuplicateModal_modalWrapper__56czI {
    position: inherit;
    bottom: 0;
    width: 100%;
  }
  .DuplicateModal_btnRow__P4\\+BN {
    justify-content: center;
  }
  .DuplicateModal_inputColumn__8wuks {
    margin-bottom: 200px;
    max-width: 100%;
    gap: 10px;
  }
  .DuplicateModal_modalInput__AsV9w {
    box-sizing: border-box;
    padding: 20px;
  }
}

@media screen and (max-width: 600px) {
  .DuplicateModal_infoModal__lDHh7 {
    width: 90%;
  }
}

@media screen and (max-width: 440px) {
  .DuplicateModal_successBtn__Gi7uF,
  .DuplicateModal_cancelBtn__aThte {
    width: 46%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/scenes/singleGroup/components/DuplicateGroupModal/DuplicateModal.module.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,SAAS;EACT,UAAU;EACV,YAAY;EACZ,2BAA2B;EAC3B,YAAY;AACd;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,sBAAsB;EACtB,UAAU;EACV,0BAA0B;EAC1B,uBAAuB;EACvB,SAAS;AACX;AACA;EACE,kBAAkB;EAClB,OAAO;EACP,SAAS;EACT,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;EACxB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;;;EAGE,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,2BAA2B;EAC3B,sBAAsB;EACtB,UAAU;EACV,mBAAmB;EACnB,yBAAyB;EACzB,qCAAqC;EACrC,yBAAyB;AAC3B;AACA;EACE,WAAW;EACX,SAAS;EACT,gBAAgB;AAClB;AACA;;EAEE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,uBAAuB;AACzB;AACA;EACE,UAAU;AACZ;AACA;EACE,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,WAAW;AACb;AACA;EACE,yBAAyB;EACzB,SAAS;EACT,WAAW;EACX,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,sCAAsC;EACtC,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,wBAAwB;AAC1B;AACA;;EAEE,UAAU;EACV,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;;EAElB,eAAe;EACf,YAAY;AACd;AACA;;;EAGE,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;AAC1B;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;EACzB,cAAc;AAChB;AACA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE;IACE,WAAW;IACX,QAAQ;EACV;EACA;;IAEE,UAAU;EACZ;EACA;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE;;IAEE,UAAU;EACZ;AACF;;AAEA;EACE;;IAEE,UAAU;EACZ;EACA;IACE,iBAAiB;IACjB,SAAS;IACT,WAAW;EACb;EACA;IACE,uBAAuB;EACzB;EACA;IACE,oBAAoB;IACpB,eAAe;IACf,SAAS;EACX;EACA;IACE,sBAAsB;IACtB,aAAa;EACf;AACF;;AAEA;EACE;IACE,UAAU;EACZ;AACF;;AAEA;EACE;;IAEE,UAAU;EACZ;AACF","sourcesContent":[".modalOverlay {\n  position: fixed;\n  top: 0;\n  left: 15%;\n  width: 85%;\n  height: 100%;\n  background-color: #000000d6;\n  z-index: 100;\n}\n.modalOverlay {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.infoModal {\n  flex-direction: column;\n  width: 70%;\n  padding: 24px 0px 24px 0px;\n  justify-content: center;\n  gap: 24px;\n}\n.exitBtn {\n  position: absolute;\n  top: 5%;\n  right: 3%;\n  cursor: pointer;\n}\n.title {\n  font-family: Inter;\n  font-size: 28px;\n  font-weight: 600;\n  line-height: 34px;\n  letter-spacing: -0.001em;\n  text-align: left;\n  color: #4d4d4d;\n}\n\n.infoModal,\n.btnRow,\n.modalWrapper {\n  display: flex;\n  align-items: center;\n}\n.modalWrapper {\n  justify-content: flex-start;\n  flex-direction: column;\n  width: 60%;\n  border-radius: 16px;\n  border: 1px solid #d1d9e2;\n  box-shadow: 0px 1px 2px 0px #1018280d;\n  background-color: #ffffff;\n}\n.inputWrapper {\n  width: 100%;\n  gap: 16px;\n  margin-top: 24px;\n}\n.inputWrapper,\n.inputColumn {\n  display: flex;\n  flex-direction: column;\n  align-items: baseline;\n  justify-content: center;\n}\n.inputColumn {\n  width: 98%;\n}\n.label {\n  text-align: left;\n  color: #5f6d7e;\n}\n.modalInput {\n  width: 100%;\n}\n.btnRow {\n  justify-content: flex-end;\n  gap: 24px;\n  width: 100%;\n  margin-top: 48px;\n  margin-bottom: 32px;\n}\n.modalInput {\n  padding: 8px;\n  height: 42px;\n  border: 1px solid #d8dbdf;\n  border-radius: 8px;\n  text-align: left;\n  color: #5f6d7e;\n  box-shadow: 4px 4px 64px 0px #5f6d7e1a;\n  font-family: Inter;\n  font-size: 16px;\n  font-weight: 500;\n  letter-spacing: -0.001em;\n}\n.cancelBtn,\n.successBtn {\n  width: 30%;\n  border: none;\n  padding: 8px 16px;\n  border-radius: 4px;\n\n  cursor: pointer;\n  height: 52px;\n}\n.cancelBtn,\n.successBtn,\n.label {\n  font-family: Inter;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 22px;\n  letter-spacing: -0.016px;\n}\n\n.successBtn {\n  background: #cb9c2d;\n  color: #fff;\n}\n.successBtn:hover {\n  background-color: #9b7725;\n}\n.cancelBtn {\n  background-color: #ebebeb;\n  color: #808080;\n}\n.cancelBtn:hover {\n  background-color: #a09f9f;\n  color: #fff;\n}\n\n@media screen and (max-width: 1300px) {\n  .modalOverlay {\n    width: 100%;\n    left: 0%;\n  }\n  .successBtn,\n  .cancelBtn {\n    width: 35%;\n  }\n  .btnRow {\n    margin-bottom: 0px;\n  }\n}\n\n@media screen and (max-width: 1050px) {\n  .successBtn,\n  .cancelBtn {\n    width: 40%;\n  }\n}\n\n@media screen and (max-width: 920px) {\n  .successBtn,\n  .cancelBtn {\n    width: 40%;\n  }\n  .modalWrapper {\n    position: inherit;\n    bottom: 0;\n    width: 100%;\n  }\n  .btnRow {\n    justify-content: center;\n  }\n  .inputColumn {\n    margin-bottom: 200px;\n    max-width: 100%;\n    gap: 10px;\n  }\n  .modalInput {\n    box-sizing: border-box;\n    padding: 20px;\n  }\n}\n\n@media screen and (max-width: 600px) {\n  .infoModal {\n    width: 90%;\n  }\n}\n\n@media screen and (max-width: 440px) {\n  .successBtn,\n  .cancelBtn {\n    width: 46%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modalOverlay": `DuplicateModal_modalOverlay__NIZ69`,
	"infoModal": `DuplicateModal_infoModal__lDHh7`,
	"exitBtn": `DuplicateModal_exitBtn__3yNGh`,
	"title": `DuplicateModal_title__TLD4D`,
	"btnRow": `DuplicateModal_btnRow__P4+BN`,
	"modalWrapper": `DuplicateModal_modalWrapper__56czI`,
	"inputWrapper": `DuplicateModal_inputWrapper__aJIe7`,
	"inputColumn": `DuplicateModal_inputColumn__8wuks`,
	"label": `DuplicateModal_label__oD8Is`,
	"modalInput": `DuplicateModal_modalInput__AsV9w`,
	"cancelBtn": `DuplicateModal_cancelBtn__aThte`,
	"successBtn": `DuplicateModal_successBtn__Gi7uF`
};
export default ___CSS_LOADER_EXPORT___;
